import React from 'react';
import { LegalShell } from '../components/legal/LegalShell';
export function Reembolsos() {
  return <LegalShell title="Política de reembolsos" data-id="element-1193">
      <p data-id="element-1194">LOS 12 es un producto digital de descarga y acceso inmediato.</p>
      <p data-id="element-1195">
        Por la naturaleza del contenido, todas las compras son finales y no
        admiten devolución una vez entregado el acceso.
      </p>
      <p data-id="element-1196">
        Si experimentas un problema técnico que te impide acceder a tu Reino,
        haremos lo posible por resolverlo y restaurar tu acceso.
      </p>
    </LegalShell>;
}